package one.healthium.profile.navigation.weight_history

import com.arkivanov.decompose.ComponentContext
import kotlin.time.Instant

class DefaultWeightHistoryComponent(
    componentContext: ComponentContext,
    private val onBackClicked: () -> Unit,
    private val onWeightHistoryClicked: (Float, Instant) -> Unit,
) : WeightHistoryComponent, ComponentContext by componentContext {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }

    override fun onWeightHistoryClicked(weight: Float, date: Instant) {
        onWeightHistoryClicked.invoke(weight, date)
    }
}